import type { CurrentReleaseNoteResponse, DismissReleaseNoteResponse, ReleaseNote } from '@kangaroo/shared';

import { api } from '../lib/api';

interface ApiResponse<T> {
  data: T;
}

type LegacyCurrentReleaseNoteResponse = {
  releaseNote?: ReleaseNote | null;
};

export const currentReleaseNoteKey = '/release-notes/current';

export function normalizeCurrentReleaseNoteResponse(
  response: CurrentReleaseNoteResponse | LegacyCurrentReleaseNoteResponse,
): CurrentReleaseNoteResponse {
  if ('releaseNotes' in response && Array.isArray(response.releaseNotes)) {
    return { releaseNotes: response.releaseNotes };
  }

  const releaseNote = 'releaseNote' in response ? response.releaseNote : null;
  return { releaseNotes: releaseNote ? [releaseNote] : [] };
}

export async function fetchCurrentReleaseNote(): Promise<CurrentReleaseNoteResponse> {
  const response = await api.get<ApiResponse<CurrentReleaseNoteResponse | LegacyCurrentReleaseNoteResponse>>(currentReleaseNoteKey);
  return normalizeCurrentReleaseNoteResponse(response.data.data);
}

export async function dismissReleaseNote(releaseKey: string): Promise<DismissReleaseNoteResponse> {
  const response = await api.post<ApiResponse<DismissReleaseNoteResponse>>(`/release-notes/${encodeURIComponent(releaseKey)}/dismiss`);
  return response.data.data;
}
